define([
	"dojo/_base/declare",
	"csi/table/Aggregate",
	"csi/xml",
	"SiteAdmin"
], function(declare, Aggregate, xml, SiteAdmin) {

	return declare(Aggregate, {
		// @property {boolean} isForAssignedAgentCrew - indicates whether the table is for AssignedAgentCrewRoleUsers
		isForAssignedAgentCrew: false,
		/**
		 * @override
		 * Add current selections to form data
		 */
		onFormData(fd) {
			const reportType = "CrewAssignmentReport";
			const {m_cache, m_urlNode} = this;

			m_cache.query().forEach(({$Type, CrewDistance, Role, User}) => {
				if (($Type === reportType) && (User === m_urlNode) && (CrewDistance === 0)) {
					const role = m_cache.get(Role);
					fd.addAggregatedNode(role);
				}
			});
		},

		toWriterRequest: function() {
			const writer = this.inherited(arguments);
			const nodesRemoved = this._getAggregateRemovals(this.getFormData());
			const removes = !_.isEmpty(nodesRemoved) ? _.map(nodesRemoved, xml.nodeGetURL) : null;
			const crew = SiteAdmin.getOnlineSupplierCrew(this.getCache(), this.widget.getViewNode(), this.isForAssignedAgentCrew);
			writer.addParameter("Crew", xml.ATTR_REF, crew);
			writer.addParameter("AddURLs", xml.ATTR_REFLIST, this.m_formData.getSelectedValue());
			writer.addParameter("RemoveURLs", xml.ATTR_REFLIST, removes);
			return writer;
		},

		/**
		 * @override
		 * Fix duplicate rows on initially clicking save when adding users to roles
		 */
		postProcessSuccess: function() {
			return this.widget.refreshData();
		}
	});
});